import createIcon from '../../createIcon';

/**
 * @component @name FontDownloadOff
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNNS40ODQ3MyAxLjM0NDczSDIwLjY1NDdDMjEuNzU0NyAxLjM0NDczIDIyLjY1NDcgMi4yNDQ3MyAyMi42NTQ3IDMuMzQ0NzNWMTguNTE0N0wyMC42NTQ3IDE2LjUxNDdWMy4zNDQ3M0g3LjQ4NDczTDUuNDg0NzMgMS4zNDQ3M1pNMTEuNTc0NyA1LjM0NDczTDExLjAwNDcgNi44NjQ3M0wxMi4zNjQ3IDguMjI0NzNMMTIuNTk0NyA3LjU2NDczSDEyLjY5NDdMMTMuMjM0NyA5LjA4NDczTDE2LjI3NDcgMTIuMTI0N0wxMy43MjQ3IDUuMzQ0NzNIMTEuNTc0N1pNMjEuMTQ0NyAyMi42NTQ3TDE5LjgyNDcgMjEuMzQ0N0g0LjY1NDczQzMuNTU0NzMgMjEuMzQ0NyAyLjY1NDczIDIwLjQ0NDcgMi42NTQ3MyAxOS4zNDQ3VjQuMTc0NzNMMS4zNDQ3MyAyLjg1NDczTDIuNzU0NzMgMS40NDQ3M0wyMi41NTQ3IDIxLjI0NDdMMjEuMTQ0NyAyMi42NTQ3Wk0xNy44MjQ3IDE5LjM0NDdMMTIuNzU0NyAxNC4yNzQ3SDEwLjIzNDdMOS4xNDQ3MyAxNy4zNDQ3SDcuMDY0NzNMOS40NTQ3MyAxMC45NzQ3TDQuNjU0NzMgNi4xNzQ3M1YxOS4zNDQ3SDE3LjgyNDdaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const FontDownloadOff = createIcon('FontDownloadOff', [
  [
    'path',
    {
      d: 'M5.48473 1.34473H20.6547C21.7547 1.34473 22.6547 2.24473 22.6547 3.34473V18.5147L20.6547 16.5147V3.34473H7.48473L5.48473 1.34473ZM11.5747 5.34473L11.0047 6.86473L12.3647 8.22473L12.5947 7.56473H12.6947L13.2347 9.08473L16.2747 12.1247L13.7247 5.34473H11.5747ZM21.1447 22.6547L19.8247 21.3447H4.65473C3.55473 21.3447 2.65473 20.4447 2.65473 19.3447V4.17473L1.34473 2.85473L2.75473 1.44473L22.5547 21.2447L21.1447 22.6547ZM17.8247 19.3447L12.7547 14.2747H10.2347L9.14473 17.3447H7.06473L9.45473 10.9747L4.65473 6.17473V19.3447H17.8247Z',
      key: '8sadk2',
    },
  ],
]);

export default FontDownloadOff;
